import { useState, useEffect } from 'react';
import { useUserLocation } from '../context/LocationContext';
import { getDefaultBusinessCached, leerRestauranteGuardado } from '../services/businessService';
import { getDrivingEtaMinutes } from '../services/mapboxService';

// Restaurante único (fijo) → un solo fetch compartido (ver businessService).
const loadRestaurantCoords = () =>
  getDefaultBusinessCached()
    .then((b) => {
      const c = b?.location?.coordinates; // GeoJSON [lng, lat]
      return Array.isArray(c) && c.length === 2 ? { lng: c[0], lat: c[1] } : null;
    })
    .catch(() => null);

/**
 * Devuelve el restaurante único (Business isDefault) con todos sus campos
 * (headerBackground, banner, etc.). Comparte el fetch cacheado.
 */
export function useDefaultRestaurant() {
  // Arranca con la copia guardada (si hay) y se actualiza con la de la API.
  const [restaurant, setRestaurant] = useState(leerRestauranteGuardado);
  useEffect(() => {
    let alive = true;
    getDefaultBusinessCached()
      .then((b) => { if (alive) setRestaurant(b); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return restaurant;
}

/**
 * Minutos de manejo de la ubicación del usuario al restaurante (Mapbox Directions,
 * cacheado). Recalcula cuando cambia la dirección del usuario. null mientras carga
 * o si no se pudo calcular.
 */
export function useRestaurantEta() {
  const { location } = useUserLocation();
  const [minutes, setMinutes] = useState(null);

  useEffect(() => {
    if (!location?.lat || !location?.lng) return;
    let alive = true;
    (async () => {
      const origin = await loadRestaurantCoords();
      if (!origin || !alive) return;
      const min = await getDrivingEtaMinutes(origin, { lat: location.lat, lng: location.lng });
      if (alive) setMinutes(min);
    })();
    return () => { alive = false; };
  }, [location?.lat, location?.lng]);

  return minutes;
}
